import axios from 'axios'

export default axios.create({
  baseURL: window.imark.ajaxurl,
  timeout: 1000 * 30,
})



// WEBPACK FOOTER //
// ./src/plugins/axios.js